module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACnSURBVEhL5dRRCsIwDMbxHkT0OIpeWFDwLuoRpuCL+g84KE06F1MZ6Ac/9pA2yR629FdZYIfu9ZyhafZ4ZLYIJd/4gBvyAXdcIWfmcKfceIgMcecCq5lFzo7OBmdYjYbInTXe5gSrwRhHVCPTP9m8JD1WUIlsXjLfpC9GU+3TF1pRsQ5FqFQLzkw/oBUV61CESrXgzHQDvv4ly/9DCtYFD+mxxE8kpSfSC/VL3+OvYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-compost-heap/dark/24.png
// module id = 1950
// module chunks = 2